/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { EBIcon, EBIcon$inboundSchema } from "./ebicon.js";

/**
 * Specifies details for an icon shelf that is shown below an Animatic Card.
 */
export type AnimaticIconShelf = {
  /**
   * The icons to display on the shelf
   */
  icons: Array<EBIcon>;
};

/** @internal */
export const AnimaticIconShelf$inboundSchema: z.ZodType<
  AnimaticIconShelf,
  z.ZodTypeDef,
  unknown
> = z.object({
  icons: z.array(EBIcon$inboundSchema),
});

export function animaticIconShelfFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticIconShelf, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnimaticIconShelf$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticIconShelf' from JSON`,
  );
}
